export const SET_ROLE_SELECT = 'SET_ROLE_SELECT'
export const CLOSE_ROLE_MODAL = 'CLOSE_ROLE_MODAL'

const initialState = {
  roleSelect: null,
}

export default function (
  state = {
    ...initialState,
  },
  action = {}
) {
  switch (action.type) {
    case SET_ROLE_SELECT:
      return {
        ...state,
        roleSelect: {
          position: action.position,
          current: action.current,
          onSelect: action.onSelect,
          hasDelete: action.hasDelete,
          onDelete: action.onDelete,
          blackListRoles: action.blackListRoles || [],
        },
      }
    case CLOSE_ROLE_MODAL:
      return {
        ...state,
        roleSelect: null,
      }
    default:
      return state
  }
}
